import { TOKEN_EXPIRY_BUFFER } from '../constants/authentication.constant';

export function getTimeUntilRefresh(token: string): number {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return 0;
    }

    const [, payload] = parts;
    const decodedPayload = JSON.parse(atob(payload));
    const expiryTime = decodedPayload.exp * 1000;

    return Math.max(0, expiryTime - Date.now() - TOKEN_EXPIRY_BUFFER);
  } catch {
    return 0;
  }
}
